import { produce } from "immer";

import type { AppListenerMiddleware } from "@src/store/rootState";
import { getAgProducts, setAgProducts } from "@src/store/slices/agProducts";
import {
  addVariation,
  deleteVariation,
  selectedVariations,
} from "@src/store/slices/variations";

export function setupAgProductsListener(middleware: AppListenerMiddleware) {
  middleware.startListening({
    actionCreator: addVariation,
    effect: (action, { dispatch, getState }) => {
      const agProducts = getAgProducts(getState()) ?? [];
      const variations = selectedVariations(getState());
      const variation = variations.find((v) => v.id === action.payload);
      if (!variation) {
        return;
      }

      const updated = produce(agProducts, (draft) => {
        for (const product of draft) {
          if (!product.variationPrices[variation.id]) {
            product.variationPrices[variation.id] = {
              id: product.variantId,
              variationId: variation.id,
              name: variation.name ?? "",
              price: null,
              ogPrice: product.variantPrice,
              compareAtPrice: null,
              ogCompareAtPrice: null,
              subscriptionDiscount: null,
              subscriptionDiscountType: null,
            };
          }
        }
      });
      dispatch(setAgProducts(updated));
    },
  });
  middleware.startListening({
    actionCreator: deleteVariation,
    effect: (action, { dispatch, getState }) => {
      const agProducts = getAgProducts(getState()) ?? [];

      const updated = produce(agProducts, (draft) => {
        for (const product of draft) {
          delete product.variationPrices[action.payload];
        }
      });
      dispatch(setAgProducts(updated));
    },
  });
}
